import React, { useState, useEffect } from "react";
import "../../assets/css/common.css";
import { randomImageEndpoint, randomImageFolderAssets } from '../../assets/data/constants';
import { BibleOfTheDay } from '../../components/bible/BibleOfThDay';

export const HotNews = () => {
    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            const mediaUrl = `${randomImageEndpoint}?folder=asset`;
            try {
                const response = await fetch(mediaUrl);
                if (response.ok) {
                    const fileName = await response.text();
                    setPhoto(`${randomImageFolderAssets}${fileName}`);
                } else {
                    console.error("Failed to fetch image");
                }
            } catch (error) {
                console.error("Error fetching the image:", error);
            }
        };

        fetchImage();
    }, []);

    return (
        <div style={s.page}>
            <BibleOfTheDay />
            {photo && (
                <img
                    width='100%'
                    src={photo}
                    alt='Hot News'
                    style={s.photo}
                />
            )}
        </div>
    );
};

const s = {
    page: {
        maxWidth: '95%',
        margin: '0 auto 50px',
        paddingTop: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    photo: {
        display: 'block',
        width: '100%',
        borderRadius: '12px',
        boxShadow: '0 6px 20px rgba(92, 61, 46, 0.15)',
    },
}
